import { type PropsWithChildren } from "react"

type ConditionalRenderProps = PropsWithChildren<{
  condition: boolean
}>

const ConditionalRender = ({
  children,
  condition,
}: ConditionalRenderProps): JSX.Element | null => {
  if (!Boolean(condition)) return null

  return <>{children}</>
}

export default ConditionalRender
